import {
  HeartFilledIcon,
  HeartOutlineIcon,
  SmileyIcon,
  SmileyPlainIcon,
  StarFilledIcon,
  StarIcon,
} from '@sketchnote/icons';
import { useEffect, useState } from 'react';

export const Rating = ({
  higherRange = 5,
  onChange,
  currentRating,
  type,
  disabled = false,
}: {
  higherRange?: number;
  currentRating?: number;
  onChange?: (value: number) => void;
  type?: 'star' | 'heart' | 'smile';
  disabled?: boolean;
}) => {
  const [rating, setRating] = useState(-1);
  const [hover, setHover] = useState(-1);
  const handleOnClickRating = (index: number) => {
    setRating(index);

    onChange?.(index + 1);
  };

  useEffect(() => {
    if (currentRating) setRating(currentRating);
  }, [currentRating]);

  return (
    <div className="flex flex-wrap" onMouseLeave={() => setHover(-1)}>
      {[...Array(higherRange)].map((star, index) => {
        return (
          <button
            type="button"
            key={index}
            className="mr-12"
            disabled={disabled}
            onClick={() => handleOnClickRating(index)}
            onMouseEnter={() => (disabled ? null : setHover(index))}
          >
            {type === 'smile' ? (
              <>
                {(hover === -1 && index <= rating) || index <= hover ? (
                  <SmileyIcon className="text-gray-200  block" size={32} />
                ) : (
                  <SmileyPlainIcon
                    className="text-blue-500 cursor-pointer transition ease-in-out"
                    size={32}
                  />
                )}
              </>
            ) : type === 'heart' ? (
              <>
                {(hover === -1 && index <= rating) || index <= hover ? (
                  <HeartFilledIcon size={32} className="transition ease-in-out" />
                ) : (
                  <HeartOutlineIcon size={32} />
                )}
              </>
            ) : (
              <>
                {(hover === -1 && index <= rating) || index <= hover ? (
                  <StarFilledIcon
                    className="text-blue-500 transition ease-in-out inline-block"
                    size={32}
                  />
                ) : (
                  <StarIcon className="text-gray-200" size={32} />
                )}
              </>
            )}
          </button>
        );
      })}

      <button type="button" onClick={() => setRating(-1)} className="-mt-2 text-sm text-gray-500">
        Clear
      </button>
    </div>
  );
};
